
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Icon awesome-info-circle","d":"M32 0a32 32 0 1032 32A32 32 0 0032 0zm0 14.2a5.42 5.42 0 11-5.42 5.41A5.42 5.42 0 0132 14.19zM39.23 47a1.56 1.56 0 01-1.55 1.55H26.32A1.55 1.55 0 0124.78 47v-3.1a1.55 1.55 0 011.54-1.55h1.55v-8.28h-1.55a1.55 1.55 0 01-1.54-1.55v-3.1a1.54 1.54 0 011.54-1.55h8.26a1.54 1.54 0 011.55 1.55v12.9h1.55a1.55 1.55 0 011.54 1.55z"}})])
          )
        }
      }
    